/* ============================================
   East FAQ Section — east-faq-section.js
   Upload to: Assets
   ============================================ */

(function () {
  'use strict';

  function initEastFAQ(section) {
    var items = section.querySelectorAll('.east-faq-item');

    items.forEach(function (item) {
      var btn = item.querySelector('.east-faq-question');
      var answer = item.querySelector('.east-faq-answer-wrapper');

      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('east-faq-is-open');

        /* Close all open items in this section */
        items.forEach(function (other) {
          if (other !== item && other.classList.contains('east-faq-is-open')) {
            closeItem(other);
          }
        });

        /* Toggle clicked item */
        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }

  function openItem(item) {
    var btn = item.querySelector('.east-faq-question');
    var answer = item.querySelector('.east-faq-answer-wrapper');
    var inner = item.querySelector('.east-faq-answer');

    item.classList.add('east-faq-is-open');
    btn.setAttribute('aria-expanded', 'true');

    answer.removeAttribute('hidden');
    answer.classList.add('east-faq-is-open');

    /* Animate to full height */
    var targetHeight = inner ? inner.scrollHeight + 12 : 200;
    answer.style.maxHeight = targetHeight + 'px';
  }

  function closeItem(item) {
    var btn = item.querySelector('.east-faq-question');
    var answer = item.querySelector('.east-faq-answer-wrapper');

    item.classList.remove('east-faq-is-open');
    btn.setAttribute('aria-expanded', 'false');
    answer.classList.remove('east-faq-is-open');
    answer.style.maxHeight = '0px';

    /* Re-add hidden after transition ends for accessibility */
    answer.addEventListener('transitionend', function handler() {
      if (!item.classList.contains('east-faq-is-open')) {
        answer.setAttribute('hidden', '');
      }
      answer.removeEventListener('transitionend', handler);
    });
  }

  /* Init all FAQ sections on DOMContentLoaded */
  function init() {
    var sections = document.querySelectorAll('.east-faq-section');
    sections.forEach(function (section) {
      initEastFAQ(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor: re-init on section load */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.east-faq-section');
    if (section) initEastFAQ(section);
  });

})();